// extracted by mini-css-extract-plugin
module.exports = {"landing":"landing[Frida]1uhFKts0","submotivation":"submotivation[Frida]3jKptKj-","motivation":"motivation[Frida]1RYLCEhs"};